// TEMP: Oqaabi landing page switch. Remove after campaign.
export const SHOW_CHAT_WIDGET = false;
export const SHOW_OQAABI_LANDING = true;
